import { render, staticRenderFns } from "./FactorHistoryModal.vue?vue&type=template&id=1c48b7e6&scoped=true"
import script from "./FactorHistoryModal.vue?vue&type=script&lang=js"
export * from "./FactorHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./FactorHistoryModal.vue?vue&type=style&index=0&id=1c48b7e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c48b7e6",
  null
  
)

export default component.exports